/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 ..\first-floor.glb --transform 
Files: ..\first-floor.glb [27.68MB] > C:\Users\fabia\OneDrive\Dokumente\Dateien\To-Do\IDPA_BM-Campus\glb\gltfjsx\first-floor-transformed.glb [971.36KB] (96%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'

export function FirstFloorModel(props) {
  const { nodes, materials } = useGLTF('/models/first-floor-transformed.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes['first-floor'].geometry} material={materials['Benutzerdefiniert (4)']} position={[-10, 0, -18.5]} rotation={[Math.PI / 2, 0, 0]} scale={0.001} />
    </group>
  )
}

useGLTF.preload('/models/first-floor-transformed.glb')
